import * as React from 'react';

import styles from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/styles';
import HelpTipCardWithDialog from 'bundles/degree-home/components/v3-dpm/components/HelpTips/HelpTipCardWithDialog';
import NeedMoreFlexibilityContent from 'bundles/degree-home/components/v3-dpm/components/HelpTips/NeedMoreFlexibilityContent';
import { useProgramVariation } from 'bundles/degree-home/components/v3-dpm/context/ProgramVariation';

import _t from 'i18n!nls/degree-home';

const TipNeedMoreFlexibility: React.VFC = () => {
  const { supportsStackability } = useProgramVariation();
  if (!supportsStackability) {
    return null;
  }

  return (
    <HelpTipCardWithDialog
      title={_t('Need more flexibility?')}
      tip={_t('Enroll in a non-credit degree course and upgrade to for-credit later.')}
      dialogTitle={_t('Academic Tips')}
      dialogMessage={<NeedMoreFlexibilityContent css={styles.modalContentSegmentPadding} />}
    />
  );
};

export default TipNeedMoreFlexibility;
